import { useState } from "react";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "../../lib/api";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter,
} from "../ui/dialog";

export default function ChangePasswordDialog({ open, onOpenChange }) {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [saving, setSaving] = useState(false);

  const reset = () => { setCurrent(""); setNext(""); setConfirm(""); };

  const submit = async (e) => {
    e.preventDefault();
    if (next !== confirm) { toast.error("New passwords don't match"); return; }
    if (next.length < 6) { toast.error("New password must be at least 6 characters"); return; }
    setSaving(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: next });
      toast.success("Password updated");
      reset();
      onOpenChange(false);
    } catch (err) {
      toast.error("Couldn't update password", { description: formatApiErrorDetail(err.response?.data?.detail) });
    } finally {
      setSaving(false);
    }
  };

  const field = "w-full bg-transparent border-0 border-b border-brand-borderStrong py-2 text-sm text-brand-ink focus:outline-none focus:border-brand-primary transition-colors";

  return (
    <Dialog open={open} onOpenChange={(o) => { onOpenChange(o); if (!o) reset(); }}>
      <DialogContent className="bg-brand-page border-brand-border" data-testid="change-password-dialog">
        <DialogHeader>
          <DialogTitle className="font-serif text-2xl font-light text-brand-ink">Change password</DialogTitle>
          <DialogDescription className="text-sm text-brand-muted">Enter your current password and choose a new one.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-5 pt-2">
          <div>
            <label className="text-[10px] uppercase tracking-[0.15em] text-brand-tertiary">Current Password</label>
            <input type="password" required value={current} onChange={(e) => setCurrent(e.target.value)} data-testid="cp-current" className={field} />
          </div>
          <div>
            <label className="text-[10px] uppercase tracking-[0.15em] text-brand-tertiary">New Password</label>
            <input type="password" required value={next} onChange={(e) => setNext(e.target.value)} data-testid="cp-new" className={field} placeholder="min 6 characters" />
          </div>
          <div>
            <label className="text-[10px] uppercase tracking-[0.15em] text-brand-tertiary">Confirm New Password</label>
            <input type="password" required value={confirm} onChange={(e) => setConfirm(e.target.value)} data-testid="cp-confirm" className={field} />
          </div>
          <DialogFooter>
            <button type="submit" disabled={saving} data-testid="cp-submit"
              className="w-full bg-brand-primary text-brand-page py-3 text-sm tracking-wide hover:bg-brand-primaryHover active:scale-[0.98] transition-all duration-200 disabled:opacity-60">
              {saving ? "Updating\u2026" : "Update Password"}
            </button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
